module.exports = __webpack_public_path__ + "img/freewave2_04.d8c78102.jpg";